import type { AppDispatch } from '../store';
import type { NavigateFunction } from 'react-router-dom';
import { logout } from '../store/slices/authSlice';
import { resetMdtDispatchState } from '../store/slices/dispatchSlice';
import { stopSession } from './mdtSession';
import { clearMdtStorage, getStoredMdtEvent } from './mdtSessionStorage';

export async function logoutMdt(
  dispatch: AppDispatch,
  navigate: NavigateFunction,
  token: string | null
): Promise<void> {
  let resourceId: string | undefined;
  let eventId: string | undefined;
  try {
    const stored = localStorage.getItem('c2_mdt_resource');
    if (stored) {
      const parsed = JSON.parse(stored);
      resourceId = parsed?.id;
      eventId = parsed?.eventId;
    }
  } catch { /* ignore */ }
  if (!eventId) eventId = getStoredMdtEvent()?.id;

  await stopSession(token, resourceId, eventId);
  clearMdtStorage();
  dispatch(resetMdtDispatchState());
  dispatch(logout());
  navigate('/login', { replace: true });
}
